export const slugify = (text: string) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

export function createLookupObject<
  T extends Record<string, any>,
  K extends keyof T,
>(array: T[], key: K): Record<T[K] & (string | number | symbol), T> {
  const lookup: Record<string | number | symbol, T> = {};
  for (const item of array) {
    lookup[item[key] as any] = item;
  }
  return lookup as Record<T[K] & (string | number | symbol), T>;
}
